const analyticPricing = (Analytic) => {
    Analytic.prototype.viewPricingFromFeatureLock = function () {
        this.track('View Pricing From Feature Lock')
    }
}

export default analyticPricing